export class MaxRectTool {
    spritePerRow: number = 0;
    extrusion: number = 0;
    MaxRect: any;
    bins: Array<any> = [];
    constructor(spritePerRow = 3, extrusion = 0) {
        this.spritePerRow = spritePerRow;
        this.extrusion = extrusion;
        this.MaxRect = {
            width: 0,
            height: 0,
            padding: 0,
            rects: [],
        };
    }

    addArray(json: any) {
        const yGrid = Math.ceil(json.length / this.spritePerRow);

        const rects = [];
        // Nos ayuda a hacer el salto en Y para poder obtener el tamaño máximo del lienzo
        let yJump = false;
        // Nos ayudará a obtener las filas limite
        const maxHeight = [-1];

        for (let y = 0; y < yGrid; y++) {
            yJump = false;
            maxHeight[y] = 0;
            for (let x = 0; x < this.spritePerRow; x++) {
                if (json[y * this.spritePerRow + x] !== undefined) {
                    const jsonOutput: any = {
                        x:
                            rects[y * this.spritePerRow + (x - 1)] !== undefined && yJump
                                ? rects[y * this.spritePerRow + (x - 1)].x +
                                  rects[y * this.spritePerRow + (x - 1)].width +
                                  this.extrusion * 2
                                : this.extrusion,
                        y:
                            rects[(y - 1) * this.spritePerRow + x] !== undefined
                                ? maxHeight[y - 1] === undefined
                                    ? 0
                                    : maxHeight[y - 1] + this.extrusion * 2
                                : this.extrusion,
                        width: json[y * this.spritePerRow + x].width,
                        height: json[y * this.spritePerRow + x].height,
                        data: json[y * this.spritePerRow + x].data,
                    };
                    yJump = true;
                    rects.push(jsonOutput);
                    // Obtener el height máximo y el width máximo
                    if (yJump) {
                        if (
                            this.MaxRect.width <
                            rects[y * this.spritePerRow + x].x +
                                rects[y * this.spritePerRow + x].width
                        ) {
                            this.MaxRect.width =
                                rects[y * this.spritePerRow + x].x +
                                rects[y * this.spritePerRow + x].width +
                                this.extrusion;
                        }
                        if (
                            this.MaxRect.height <
                            rects[y * this.spritePerRow + x].y +
                                rects[y * this.spritePerRow + x].height
                        ) {
                            this.MaxRect.height =
                                rects[y * this.spritePerRow + x].y +
                                rects[y * this.spritePerRow + x].height +
                                this.extrusion;
                        }

                        if (
                            maxHeight[y] <
                            rects[y * this.spritePerRow + x].y +
                                rects[y * this.spritePerRow + x].height
                        ) {
                            maxHeight[y] =
                                rects[y * this.spritePerRow + x].y +
                                rects[y * this.spritePerRow + x].height;
                        }
                    }
                }
            }
        }
        this.MaxRect.rects = rects;
        this.bins = [this.MaxRect];
    }
}
